/* PILY MART Wishlist
 * Saves wishlisted products in the shopper's browser (no account needed).
 * Adds: header heart icon with count, heart on every product card,
 * "Add to Wishlist" button on product pages, and the /pages/wishlist page.
 */
(function () {
  'use strict';
  if (window.PilyWishlist) return;

  var CFG = window.pilyWishlistConfig || {};
  var KEY = 'pily-wishlist-v1';
  var PAGE_URL = CFG.pageUrl || '/pages/wishlist';
  var CART_URL = CFG.cartUrl || '/cart';
  var ROOT = (CFG.rootUrl || '/').replace(/\/$/, '');

  var HEART =
    '<svg class="pily-wl__heart" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.6s-7.6-4.6-9.5-9.3C1.1 7.8 3.3 4.4 6.8 4.4c2.1 0 3.6 1.2 4.4 2.5.2.3.6.3.8 0 .8-1.3 2.3-2.5 4.4-2.5 3.5 0 5.7 3.4 4.3 6.9-1.9 4.7-9.5 9.3-9.5 9.3z"' +
    ' fill="var(--pily-wl-fill, none)" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  /* ---------- storage ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    syncAll();
    document.dispatchEvent(new CustomEvent('pily-wishlist:change', { detail: { items: list } }));
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function add(h) { var l = read(); if (l.indexOf(h) === -1) { l.unshift(h); write(l); } }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }
  function toggle(h) { if (has(h)) { remove(h); return false; } add(h); return true; }

  /* ---------- helpers ---------- */
  function handleFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function num(dec, thou, decSep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(2, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(html) {
    var t = document.querySelector('.pily-wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'pily-wl-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- buttons ---------- */
  function setButtonState(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? 'Remove from wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    btn.title = label;
    var txt = btn.querySelector('.pily-wl__label');
    var want = on ? 'Saved to Wishlist' : 'Add to Wishlist';
    if (txt && txt.textContent !== want) txt.textContent = want;
  }

  function onToggleClick(e) {
    var btn = e.target.closest('[data-pily-wl-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-handle');
    if (!h) return;
    var nowOn = toggle(h);
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
    toast(nowOn
      ? 'Added to your wishlist. <a href="' + PAGE_URL + '">View wishlist</a>'
      : 'Removed from your wishlist.');
  }

  function cardButton(h) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pily-wl-card-btn';
    b.setAttribute('data-pily-wl-toggle', '');
    b.setAttribute('data-handle', h);
    b.innerHTML = HEART;
    setButtonState(b, has(h));
    return b;
  }

  // Custom card blocks (e.g. the home page "trending" grid) use class names like
  // "ai-trending-product-card-xyz". Match a card wrapper, not its inner __parts.
  var CUSTOM_CARD_RE = /(^|\s)[\w-]*product-card(-[a-z0-9]+)?(?=\s|$)/;
  function isCustomCard(el) {
    if (el.tagName === 'PRODUCT-CARD') return false;
    var cls = typeof el.className === 'string' ? el.className : '';
    if (!CUSTOM_CARD_RE.test(cls)) return false;
    return cls.split(/\s+/).some(function (t) { return /product-card/.test(t) && t.indexOf('__') === -1 && t.indexOf('--') === -1; });
  }

  function attach(card) {
    if (card.querySelector(':scope > .pily-wl-card-btn, .pily-wl-native')) return;
    if (card.closest('.pily-wl-card') && card.closest('.pily-wl-card') !== card) return;
    if (card.closest('[data-pily-wishlist-page], header, .header')) return;
    var link = card.querySelector('a.product-card__link[href], a[href*="/products/"]');
    var h = link && handleFromUrl(link.getAttribute('href'));
    if (!h) return;
    if (!card.querySelector('img, svg.placeholder-svg, picture')) return;
    card.classList.add('pily-wl-card');
    // If the card already has its own (unconnected) wishlist heart, wire that one up
    // instead of adding a second heart.
    var own = card.querySelector('button[class*="wishlist"]:not(.pily-wl-card-btn), button[aria-label*="ishlist"]:not(.pily-wl-card-btn)');
    if (own) {
      if (!own.hasAttribute('data-pily-wl-toggle')) {
        own.setAttribute('data-pily-wl-toggle', '');
        own.setAttribute('data-handle', h);
        own.classList.add('pily-wl-native');
        setButtonState(own, has(h));
      }
      return;
    }
    card.appendChild(cardButton(h));
  }

  function enhanceCards(root) {
    var scope = root || document;
    scope.querySelectorAll('product-card').forEach(attach);
    scope.querySelectorAll('main [class*="product-card"]').forEach(function (el) {
      if (isCustomCard(el)) attach(el);
    });
  }

  function enhanceHeader() {
    document.querySelectorAll('header-actions').forEach(function (ha) {
      if (ha.querySelector('.pily-wl-header')) return;
      var a = document.createElement('a');
      a.href = PAGE_URL;
      a.className = 'pily-wl-header header-actions__action';
      a.setAttribute('aria-label', 'Wishlist');
      a.title = 'Wishlist';
      a.innerHTML = '<span class="svg-wrapper">' + HEART + '</span><span class="pily-wl-header__count" hidden></span>';
      var account = ha.querySelector(':scope > .account-button');
      ha.insertBefore(a, account || ha.firstChild);
    });
  }

  function enhanceProductPage() {
    var h = handleFromUrl(location.pathname);
    if (!h) return;
    document.querySelectorAll('product-form-component').forEach(function (form) {
      if (form.closest('.quick-add-modal, dialog')) return;
      var section = form.closest('.shopify-section') || document;
      var title = section.querySelector('h1');
      if (!title) return;
      var row = title.parentElement;
      if (row.querySelector(':scope > .pily-wl-pdp-icon')) return;
      // Round heart icon next to the product title (same style as the cards)
      var b = cardButton(h);
      b.classList.add('pily-wl-pdp-icon');
      row.classList.add('pily-wl-title-row');
      row.appendChild(b);
    });
  }

  /* ---------- round variant swatches: show the chosen value next to the option name ---------- */
  function enhanceSwatches() {
    document.querySelectorAll('variant-picker fieldset.variant-option--buttons').forEach(function (fs) {
      fs.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        var input = label.querySelector('input');
        if (input && label.title !== input.value) label.title = input.value;
      });
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var checked = fs.querySelector('input:checked');
      var want = checked ? checked.value : '';
      var span = legend.querySelector('.pily-opt-value');
      if (!span) {
        span = document.createElement('span');
        span.className = 'pily-opt-value';
        legend.appendChild(span);
      }
      if (span.textContent !== want) span.textContent = want;
    });
  }

  /* ---------- "Buy it now" button (replaces Shop Pay / "More payment options") ---------- */
  function buyNowTargets(form) {
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var id = idInput && Number(idInput.value);
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    return { id: id, qty: qty };
  }

  function enhanceBuyNow() {
    document.querySelectorAll('.accelerated-checkout-block').forEach(function (block) {
      var form = block.closest('product-form-component');
      if (!form) return;
      var btn = block.parentElement.querySelector(':scope > .pily-buy-now');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button pily-buy-now';
        btn.textContent = 'Buy it now';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var t = buyNowTargets(form);
          if (!t.id) return;
          btn.disabled = true;
          btn.textContent = 'Going to checkout…';
          // Cart permalink: opens checkout with just this item and quantity,
          // the same way Shopify's own "Buy it now" button works.
          location.href = ROOT + '/cart/' + t.id + ':' + t.qty;
        });
        block.parentElement.insertBefore(btn, block);
        block.classList.add('pily-hide-accelerated');
      }
      // Mirror the Add to cart button: disabled when the variant is sold out/unavailable.
      var atc = form.querySelector('.add-to-cart-button, button[name="add"], button[type="submit"]');
      var off = !!(atc && atc.disabled);
      if (btn.disabled !== off && btn.textContent === 'Buy it now') btn.disabled = off;
    });
  }

  function syncAll() {
    var list = read();
    document.querySelectorAll('[data-pily-wl-toggle]').forEach(function (b) {
      setButtonState(b, list.indexOf(b.getAttribute('data-handle')) !== -1);
    });
    var countText = list.length > 99 ? '99+' : String(list.length);
    document.querySelectorAll('.pily-wl-header__count').forEach(function (c) {
      // Only touch the DOM when something changed, so the MutationObserver doesn't loop.
      if (c.textContent !== countText) c.textContent = countText;
      if (c.hidden !== (list.length === 0)) c.hidden = list.length === 0;
    });
  }

  /* ---------- wishlist page ---------- */
  function fetchProduct(h) {
    return fetch(ROOT + '/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function refreshCartBubble() {
    fetch(ROOT + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (el) {
          el.textContent = cart.item_count < 100 ? cart.item_count : '';
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        document.querySelectorAll('.cart-bubble').forEach(function (el) {
          el.classList.toggle('visually-hidden', cart.item_count === 0);
        });
      }).catch(function () {});
  }

  function addToCart(items) {
    return fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    });
  }

  function variantSelect(p) {
    if (p.variants.length <= 1) return '';
    return '<label class="visually-hidden" for="wl-v-' + p.id + '">Option</label>' +
      '<select class="pily-wl-item__variant" id="wl-v-' + p.id + '">' +
      p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
          esc(v.title) + ' – ' + formatMoney(v.price) + (v.available ? '' : ' (sold out)') + '</option>';
      }).join('') + '</select>';
  }

  function itemHtml(p, h, shared) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var img = p.featured_image ? p.featured_image.replace(/^\/\//, 'https://') : '';
    var imgUrl = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    var compare = p.compare_at_price && p.compare_at_price > p.price
      ? ' <s class="pily-wl-item__compare">' + formatMoney(p.compare_at_price) + '</s>' : '';
    var available = p.available;
    return '<li class="pily-wl-item" data-handle="' + esc(h) + '">' +
      '<a class="pily-wl-item__media" href="' + esc(p.url) + '">' +
        (imgUrl ? '<img src="' + esc(imgUrl) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') +
      '</a>' +
      (shared ? '' : '<button type="button" class="pily-wl-item__remove" data-wl-remove aria-label="Remove ' + esc(p.title) + ' from wishlist">&times;</button>') +
      '<div class="pily-wl-item__info">' +
        '<a class="pily-wl-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="pily-wl-item__price">' + formatMoney(p.price) + compare + '</p>' +
        variantSelect(p) +
        '<button type="button" class="button pily-wl-item__add" data-wl-add data-variant="' + (v ? v.id : '') + '"' + (available ? '' : ' disabled') + '>' +
          (available ? 'Add to cart' : 'Sold out') + '</button>' +
      '</div></li>';
  }

  function renderPage(root) {
    var params = new URLSearchParams(location.search);
    var sharedParam = params.get('items');
    var shared = !!sharedParam;
    var handles = shared
      ? sharedParam.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 60)
      : read();

    var head = root.querySelector('[data-wl-head]');
    var grid = root.querySelector('[data-wl-grid]');
    var empty = root.querySelector('[data-wl-empty]');
    var actions = root.querySelector('[data-wl-actions]');
    var sharedBar = root.querySelector('[data-wl-shared]');

    sharedBar.hidden = !shared;
    actions.hidden = shared || handles.length === 0;

    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      head.textContent = shared ? 'This shared wishlist is empty.' : '';
      return;
    }
    empty.hidden = true;
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = handles.map(function () { return '<li class="pily-wl-item pily-wl-item--loading"></li>'; }).join('');

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var html = '';
      var valid = [];
      products.forEach(function (p, i) {
        if (!p) return;
        valid.push(p.handle);
        html += itemHtml(p, p.handle, shared);
      });
      // Clean up removed/renamed products in the saved list
      if (!shared) {
        var stale = handles.filter(function (h) { return valid.indexOf(h) === -1; });
        if (stale.length) {
          var l = read().filter(function (h) { return stale.indexOf(h) === -1; });
          products.forEach(function (p, i) { if (p && p.handle !== handles[i] && l.indexOf(p.handle) === -1) l.push(p.handle); });
          try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
          syncAll();
        }
      }
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      var n = valid.length;
      head.textContent = n + (n === 1 ? ' saved item' : ' saved items');
      empty.hidden = n > 0;
      actions.hidden = shared || n === 0;
    });
  }

  function initPage() {
    var root = document.querySelector('[data-pily-wishlist-page]');
    if (!root) return;
    renderPage(root);

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('.pily-wl-item__variant');
      if (!sel) return;
      var btn = sel.closest('.pily-wl-item').querySelector('[data-wl-add]');
      btn.setAttribute('data-variant', sel.value);
    });

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wl-remove]');
      if (rm) {
        var li = rm.closest('.pily-wl-item');
        remove(li.getAttribute('data-handle'));
        renderPage(root);
        return;
      }
      var addBtn = e.target.closest('[data-wl-add]');
      if (addBtn) {
        var id = Number(addBtn.getAttribute('data-variant'));
        if (!id) return;
        addBtn.disabled = true;
        var label = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        addToCart([{ id: id, quantity: 1 }]).then(function () {
          addBtn.textContent = 'Added ✓';
          refreshCartBubble();
          toast('Added to cart. <a href="' + CART_URL + '">View cart</a>');
          setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 1800);
        }).catch(function (err) {
          addBtn.textContent = label; addBtn.disabled = false;
          toast(esc(err.message));
        });
        return;
      }
      if (e.target.closest('[data-wl-add-all]')) {
        var items = [];
        root.querySelectorAll('[data-wl-add]:not([disabled])').forEach(function (b) {
          var vid = Number(b.getAttribute('data-variant'));
          if (vid) items.push({ id: vid, quantity: 1 });
        });
        if (!items.length) return;
        addToCart(items).then(function () {
          refreshCartBubble();
          toast(items.length + ' items added to cart. <a href="' + CART_URL + '">View cart</a>');
        }).catch(function (err) { toast(esc(err.message)); });
        return;
      }
      if (e.target.closest('[data-wl-clear]')) {
        if (window.confirm('Remove all items from your wishlist?')) { write([]); renderPage(root); }
        return;
      }
      if (e.target.closest('[data-wl-share]')) {
        var url = location.origin + PAGE_URL + '?items=' + encodeURIComponent(read().join(','));
        var done = function () { toast('Wishlist link copied. Share it with friends and family!'); };
        if (navigator.share) {
          navigator.share({ title: 'My PILY MART Wishlist', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
        } else {
          window.prompt('Copy this link:', url);
        }
        return;
      }
      if (e.target.closest('[data-wl-save-shared]')) {
        var p = new URLSearchParams(location.search).get('items') || '';
        var l = read();
        p.split(',').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (h) {
          if (l.indexOf(h) === -1) l.push(h);
        });
        write(l);
        location.href = PAGE_URL;
      }
    });

    document.addEventListener('pily-wishlist:change', function () {
      if (!new URLSearchParams(location.search).get('items')) renderPage(root);
    });
  }

  /* ---------- boot ---------- */
  function run() {
    enhanceHeader();
    enhanceCards();
    enhanceProductPage();
    enhanceBuyNow();
    enhanceSwatches();
    syncAll();
  }

  function boot() {
    document.addEventListener('click', onToggleClick, true);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-picker')) enhanceSwatches();
    });
    run();
    initPage();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });
  }

  window.PilyWishlist = { read: read, add: add, remove: remove, toggle: toggle, has: has };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
